import type { ReactNode } from 'react';

import { InfoTipIcon } from '../icon/InfoTipIcon';
import { RevelioTooltip } from '../tooltip/RevelioTooltip';
import styles from './TreeTooltip.module.css';

/**
 * Info tooltip used inside tree rows. A wider, roomier variant of
 * `RevelioTooltip` — the extra padding and width come from `styles.tooltip`
 * rather than props, since the tooltip is CSS-styled now.
 */
export const TreeTooltip = ({
  label,
  mt = '0px',
  onOpen,
}: {
  label: ReactNode;
  mt?: string;
  /** Called once each time the tooltip becomes visible. */
  onOpen?: () => void;
}) => (
  <RevelioTooltip
    label={label}
    placement="top"
    openDelay={0}
    maxWidth={330}
    className={styles.tooltip}
    onOpen={onOpen}
  >
    <span style={{ marginTop: mt }} className={styles.infoIcon}>
      <InfoTipIcon size={14} />
    </span>
  </RevelioTooltip>
);
